import { setCookie } from '../../../helpers/cookie';
import { DEFAULT_FLASH_MESSAGE_KEY, FLASH_EXPIRES_IN } from '../config/config';

const timeInDaysToStoreCookie = (1 / 24 / 60) * FLASH_EXPIRES_IN;
const setFlashMessage = (msg, cookieKey = DEFAULT_FLASH_MESSAGE_KEY) => setCookie(cookieKey, msg, timeInDaysToStoreCookie);

export default setFlashMessage;
